import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import TeacherView from '../views/TeacherView.vue'
import StudentAssistantView from '../views/StudentAssistantView.vue'
import PostView from '../views/PostView.vue'
import UserView from '../views/UserView.vue'
import ScheduleView from '../views/ScheduleView.vue'
import ConfigurationView from '../views/ConfigurationView.vue'
import CreateEditUser from '../components/user/CreateEditUser.vue'
import CreateEditPost from '../components/post/CreateEditPost.vue'
import CreateEditTeacher from '../components/teacher/CreateEditTeacher.vue'
import CreateEditStudentAssistant from '../components/studentAssistant/CreateEditStudentAssistant.vue'
import TeacherScheduleView from '../views/TeacherScheduleView.vue'
import UploadImage from '../components/example/UploadImage.vue'
import LoginView from "../views/LoginView.vue";
import ForgotPasswordView from '../views/ForgotPasswordView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import MySchedules from '@/views/MySchedules.vue'
import RequestVideo from '@/views/RequestVideo.vue'
import RequestedVideos from '@/views/RequestedVideos.vue'
import EventosView from '@/views/EventosView.vue'
import CompensatoriosView from '@/views/CompensatoriosView.vue'
import ConceptosView from '@/views/ConceptosView.vue'
import TasksView from '@/views/TasksView.vue'
import TaskDetailView from '@/views/TaskDetailView.vue'
import CreateTaskView from '@/views/CreateTaskView.vue'
import TaskBatchesView from '@/views/TaskBatchesView.vue'
import TasksCreatedByMeView from '@/views/TasksCreatedByMeView.vue'
import VideoTutorialsView from '@/views/VideoTutorialsView.vue'
import NotificationsAdminView from '@/views/NotificationsAdminView.vue'
import NoticiasView from '@/views/NoticiasView.vue'
import LeaveRequestsView from '@/views/LeaveRequestsView.vue'
import LeaveBalancesView from '@/views/LeaveBalancesView.vue'
import LeaveRequestWizardView from '@/views/LeaveRequestWizardView.vue'
import LeaveRequestDetailView from '@/views/LeaveRequestDetailView.vue'
import LeaveInboxView from '@/views/LeaveInboxView.vue'
import LeaveReviewView from '@/views/LeaveReviewView.vue'
import LeaveCalendarView from '@/views/LeaveCalendarView.vue'
import LeaveAdminArticlesView from '@/views/LeaveAdminArticlesView.vue'
import LeaveAdminArticleFormView from '@/views/LeaveAdminArticleFormView.vue'
import LeaveAdminArticleDetailView from '@/views/LeaveAdminArticleDetailView.vue'
import LeaveAdminLegalDocumentsView from '@/views/LeaveAdminLegalDocumentsView.vue'
import LeaveAdminLegalDocumentFormView from '@/views/LeaveAdminLegalDocumentFormView.vue'
import store from '../store';
import { isTokenExpired } from '../utils/jwt';


const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { public: true },
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: ForgotPasswordView,
    meta: { public: true },
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: ResetPasswordView,
    meta: { public: true },
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: '/',
    name: 'schedules',
    component: ScheduleView
  },
  {
    path: '/schedule/:teacher_id',
    name: 'schedule',
    component: TeacherScheduleView,
  },
  {
    path: '/teachers/:teacher_id/schedule',
    name: 'teacherSchedule',
    component: TeacherScheduleView,
  },
  {
    path: '/teachers',
    name: 'teachers',
    component: TeacherView
  },
  {
    path: '/teachers/create',
    name: 'createTeacher',
    component: CreateEditTeacher,
    meta: { roles: ['admin', 'executive', 'director'] },
  },
  {
    path: '/teachers/edit/:id',
    name: 'editTeacher',
    component: CreateEditTeacher,
    meta: { roles: ['admin', 'executive', 'director'] },
  },
  {
    path: '/preceptores',
    name: 'PreceptoresView',
    component: StudentAssistantView,
  },
  {
    path: '/preceptores/create',
    name: 'createStudentAssistant',
    component: CreateEditStudentAssistant,
    meta: { roles: ['admin', 'administrative', 'executive', 'director'] },
  },
  {
    path: '/preceptores/edit/:id',
    name: 'editStudentAssistant',
    component: CreateEditStudentAssistant,
  },
  {
    path: '/conceptos',
    name: 'ConceptosView',
    component: ConceptosView,
  },
  {
    path: '/profile/edit/:id',
    name: 'editProfile',
    component: CreateEditTeacher
  },
  {
    path: '/posts',
    name: 'posts',
    component: PostView
  },
  {
    path: '/users',
    name: 'users',
    component: UserView
  },
  {
    path: '/users/:id',
    component: CreateEditUser
  },
  {
    path: '/posts/:id',
    name: 'editPost',
    component: CreateEditPost
  },
  {
    path: '/posts/create',
    name: 'createPost',
    component: CreateEditPost
  },
  {
    path: '/configurations',
    name: 'configurations',
    component: ConfigurationView
  },
  {
    path: '/images',
    name: 'images',
    component: UploadImage
  },
  {
    path: '/my-schedules',
    name: 'MySchedules',
    component: MySchedules,
  },
  {
    path: '/request-video',
    name: 'RequestVideo',
    component: RequestVideo,
  },
  {
    path: '/requested-videos',
    name: 'RequestedVideos',
    component: RequestedVideos,
  },
  {
    path: '/leave',
    redirect: () => {
      const role = store.state.authentication.user?.role;
      return ['admin', 'executive', 'director', 'administrative'].includes(role)
        ? '/leave/inbox'
        : '/leave/requests';
    },
  },
  {
    path: '/leave/inbox',
    name: 'LeaveInboxView',
    component: LeaveInboxView,
    meta: { roles: ['admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/calendar',
    name: 'LeaveCalendarView',
    component: LeaveCalendarView,
    meta: { roles: ['admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/admin/articles',
    name: 'LeaveAdminArticlesView',
    component: LeaveAdminArticlesView,
    meta: { roles: ['admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/admin/articles/new',
    name: 'LeaveAdminArticleCreateView',
    component: LeaveAdminArticleFormView,
    meta: { roles: ['admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/admin/articles/:id/edit',
    name: 'LeaveAdminArticleEditView',
    component: LeaveAdminArticleFormView,
    meta: { roles: ['admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/admin/articles/:id',
    name: 'LeaveAdminArticleDetailView',
    component: LeaveAdminArticleDetailView,
    meta: { roles: ['admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/admin/legal-documents',
    name: 'LeaveAdminLegalDocumentsView',
    component: LeaveAdminLegalDocumentsView,
    meta: { roles: ['admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/admin/legal-documents/new',
    name: 'LeaveAdminLegalDocumentCreateView',
    component: LeaveAdminLegalDocumentFormView,
    meta: { roles: ['admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/admin/legal-documents/:id/edit',
    name: 'LeaveAdminLegalDocumentEditView',
    component: LeaveAdminLegalDocumentFormView,
    meta: { roles: ['admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/requests',
    name: 'LeaveRequestsView',
    component: LeaveRequestsView,
    meta: { roles: ['teacher', 'admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/balances',
    name: 'LeaveBalancesView',
    component: LeaveBalancesView,
    meta: { roles: ['teacher', 'admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/requests/new',
    name: 'LeaveRequestCreateView',
    component: LeaveRequestWizardView,
    meta: { roles: ['teacher', 'admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/requests/:id/edit',
    name: 'LeaveRequestEditView',
    component: LeaveRequestWizardView,
    meta: { roles: ['teacher', 'admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/requests/:id/review',
    name: 'LeaveReviewView',
    component: LeaveReviewView,
    meta: { roles: ['admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/leave/requests/:id',
    name: 'LeaveRequestDetailView',
    component: LeaveRequestDetailView,
    meta: { roles: ['teacher', 'janitor', 'rti', 'student_assistant', 'admin', 'executive', 'director', 'administrative'] },
  },
  {
    path: '/eventos',
    name: 'EventosView',
    component: EventosView,
  },
  {
    path: '/compensatorios',
    name: 'CompensatoriosView',
    component: CompensatoriosView,
  },
  {
    path: '/notificaciones',
    name: 'NotificationsAdminView',
    component: NotificationsAdminView,
    meta: { roles: ['admin'] },
  },
  {
    path: '/noticias',
    name: 'NoticiasView',
    component: NoticiasView,
    meta: { roles: ['admin', 'director'] },
  },
  {
    path: '/video-tutorials',
    name: 'VideoTutorialsView',
    component: VideoTutorialsView,
    meta: { public: true },
  },
  {
    path: '/video-tutorials/:videoSlug',
    name: 'VideoTutorialsDetail',
    component: VideoTutorialsView,
    meta: { public: true },
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },

  // --- Tasks ---
  {
    path: '/tasks',
    name: 'TasksView',
    component: TasksView,
  },
  {
    path: '/tasks/create',
    name: 'CreateTaskView',
    component: CreateTaskView,
  },
  {
    path: '/tasks/created-by-me',
    name: 'TasksCreatedByMeView',
    component: TasksCreatedByMeView,
  },
  {
    path: '/task-batches',
    name: 'TaskBatchesView',
    component: TaskBatchesView,
  },
  {
    path: '/tasks/:id',
    name: 'TaskDetailView',
    component: TaskDetailView,
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  let isAuthenticated = store.state.authentication.authenticated
  const isPublicRoute = to.matched.some((record) => record.meta?.public)

  if (isAuthenticated && isTokenExpired(store.state.authentication.token)) {
    store.dispatch('authentication/logout')
    isAuthenticated = false
  }

  if (!isAuthenticated && !isPublicRoute) {
    return next('/login')
  }

  const allowedRoles = to.matched.find((r) => r.meta?.roles)?.meta.roles
  if (allowedRoles?.length) {
    const role = store.state.authentication.user?.role
    if (!allowedRoles.includes(role)) {
      return next({ name: 'home' })
    }
  }

  next()
})

export default router
